import * as constants from './template-list-constants';
import checkStatus from '../../../utils/checkStatus';
import Promise from 'bluebird';
import R from 'ramda';
import moment from 'moment';
import queryString from 'query-string';
import { getTemplateStatus } from '../../../components/contracting/contractingUtils';

export const updateLocationProps = payload => ({ type: constants.UPDATE_LOC_PROPS, payload });
export const updateProps = payload => ({ type: constants.UPDATE_PROPS, payload });
export const updateFilters = payload => ({ type: constants.UPDATE_FILTERS, payload });
export const updateTemplateProps = (templateId, data) => ({ type: constants.UPDATE_TEMPLATE_PROPS, payload: { templateId, data } });
export const updateDraftProps = (draftId, data) => ({ type: constants.UPDATE_DRAFT_PROPS, payload: { draftId, data } });
export const archiveUnarchive = (payload) => ({ type: 'ARCHIVE_UNARCHIVE_TEMPLATE', payload });
const credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
};
const put = body => R.merge({ method: 'put', body: JSON.stringify(body) }, credentialsAndHeaders);
const getFetch = R.merge({ method: 'get' }, credentialsAndHeaders);
const post = body => R.merge({ method: 'post', body: JSON.stringify(body) }, credentialsAndHeaders);
const del = body => R.merge({ method: 'delete', body: JSON.stringify(body) }, credentialsAndHeaders);
const callApiGet = (url) => {
  return fetch(url, getFetch)
    .then(checkStatus);
};
const callApiPost = (url, body) => {
  return fetch(url, post(body))
    .then(checkStatus);
};
const getDownloadPdfLink = templateId => {
  const url = `/proxy/download-pdf`;
  const qs = queryString.stringify({
    contractIds: JSON.stringify([templateId]),
    locale: moment().utcOffset(),
    collection: 'template',
  });
  return (`${url}?${qs}`);
};
export const downloadContractPdf = (templateId, anchorEl) => dispatch => {
  dispatch({
    type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
    payload: {
      docId: templateId,
      collection: 'template',
      anchorEl,
    },
  });
};

export const downloadPdfZip = (templates, templateGroupName) => (dispatch) => {
  dispatch({
    type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
    payload: {
      templates,
      collection: 'template',
      templateGroupName,
      isBulk: true,
    },
  });
  // dispatch({ type: constants.DOWNLOADING_PDF_ZIP });
  // if (R.isEmpty(templates)) return dispatch({ type: constants.PDF_ZIP_DOWNLOADED });
};
export const deleteTemplate = (templateId) => {
  return dispatch => {
    return fetch('/proxy/contracting/template', del({ templateId }))
      .then(checkStatus)
      .then(() => dispatch({ type: constants.TEMPLATE_DELETED, payload: { templateId } }))
      .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Delete template failed' }));
  };
};
export const deleteDraft = (editedDraft, originalContractId) => {
  return dispatch => {
    return fetch(editedDraft ? `/proxy/contracting/discardEditedDraft/${originalContractId}` : '/proxy/contracting/template/draft', del({ originalContractId }))
      .then(checkStatus)
      .then(() => dispatch({ type: constants.DRAFT_DELETED, payload: { draftId: originalContractId } }))
      .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Delete draft failed' }));
  };
};
export const saveNewTemplateName = (templateOrDraft, id, newName) => {
  return dispatch => {
    dispatch({ type: constants.UPDATING_TEMPLATE_NAME, payload: { templateId: id, templateOrDraft } });
    return fetch(`/proxy/contracting/template/templateName`, put({ newName, templateId: id, templateOrDraft }))
      .then(checkStatus)
      .then(res => res.json())
      .then((res) => {
        if (res.duplicateExists) {
          dispatch({ type: constants.TEMPLATE_NAME_UPDATED_DUPLICATED, payload: { templateId: id, templateOrDraft, newName } });
        } else dispatch({ type: constants.TEMPLATE_NAME_UPDATED, payload: { templateId: id, templateOrDraft, newName } });
      })
      .catch(() => {
        dispatch({ type: constants.UPDATING_TEMPLATE_NAME, payload: { templateId: id, templateOrDraft } });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving new template name failed' });
      });
  };
};
export const createDraft = payload => {
  return dispatch => {
    dispatch({ type: constants.STARTING_DRAFT_CREATE, payload });
    return callApiPost('/proxy/contracting/draft/initialDraft', payload)
      .then(res => res.json())
      .then(res => {
        const createNewLoc = R.find(loc => (loc.checked && !loc.locationId), payload.locations);
        if (createNewLoc) {
          dispatch({ type: '[user]UPDATE_USER_LOC_ACCESS_WHEN_NEW_LOC_CREATED', payload: res.drafts.map(R.prop('locationId')) });
        }
        dispatch(getLocationsAndProducts());
        dispatch(getTemplates());
        return dispatch({ type: constants.DRAFT_CREATED, payload: res });
      })
      .catch((err) => {
        console.log(err.stack);
        dispatch({ type: constants.STARTING_DRAFT_CREATE, payload });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Create Template Draft Failed' });
      });
  };
};
export const createTemplateGroup = payload => {
  return dispatch => {
    dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
    return callApiPost('/proxy/contracting/template-group', payload)
      .then(res => res.json())
      .then(res => dispatch({ type: constants.TEMPLATE_GROUP_CREATED, payload: R.merge(payload, { groupId: res._id }) }))
      .catch((err) => {
        console.log(err.stack);
        dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Template Group Creation Failed' });
      });
  };
};
export const editTemplateGroup = payload => {
  return dispatch => {
    dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
    return fetch('/proxy/contracting/template-group', put(payload))
    .then(() => {
      dispatch({ type: constants.TEMPLATE_GROUP_UPDATED });
      dispatch(getTemplates());
    })
    .catch((err) => {
      console.log(err.stack);
      dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Template Group Edit Failed' });
    });
  };
};
export const getContractsCount = (templateIds) => {
  return dispatch => {
    return Promise.each(templateIds, templateId => {
      return callApiGet(`/proxy/contracting/template/contracts/${templateId}`)
        .then(res => res.json())
        .then(res => dispatch({ type: constants.POPULATE_CONTRACTS_COUNT, payload: { templateId, partnersCount: res.count } }));
    });
  };
};
export const getTemplates = () => {
  return dispatch => {
    dispatch({ type: constants.LOADING_TEMPLATES });
    return callApiGet(`/proxy/contracting/template-list`)
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: constants.TEMPLATES_LOADED,
          payload: R.merge(res, {
            listRefreshing: false,
          }),
        });
      }) // res = { templates, templateGroups }
      .catch(() => {
        dispatch({ type: constants.LOADING_TEMPLATES });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' })
      });
  };
};
export const getTemplatesForGroupWizard = (query) => {
  return (dispatch, getState) => {
    const locAccess = getState().user.toJS().locAccess;
    const locationIds = R.pluck('locId', locAccess.filter(loc => R.contains('write', loc.contracting)));
    dispatch({ type: constants.LOADING_TEMPLATES_FOR_WIZARD });
    const qs = query ? queryString.stringify({ additionalQuery: JSON.stringify(R.merge(query, { locationId: { $in: locationIds } })) }) : '';
    return callApiGet(`/proxy/contracting/templates?${qs}`)
      .then(res => res.json())
      .then(res => {
        dispatch({ type: constants.TEMPLATES_LOADED_FOR_WIZARD, payload: R.merge(res, { listRefreshing: false }) })
      }) // res = { templates, templateGroups }
      .catch(() => {
        dispatch({ type: constants.LOADING_TEMPLATES_FOR_WIZARD });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' });
      });
  };
};

export const getLocationsAndProducts = locationId => {
  return dispatch => {
    return callApiGet(`/proxy/contracting/getSupplierLocationsList`)
      .then(res => res.json())
      .then(payload => {
        return dispatch({ type: constants.GET_SUPPLIER_LOCATIONS_LIST, payload: R.merge(payload, { locationId }) });
      })
      .catch(() => {
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Get location list failed' });
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/template-list/template-list-actions.js